/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Artcraft_VectorInputs */

const en_fc_home_artcraft_vector = /** @type {(inputs: Fc_Home_Artcraft_VectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illustration`)
};

/**
* | output |
* | --- |
* | "Illustration" |
*
* @param {Fc_Home_Artcraft_VectorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_artcraft_vector = /** @type {((inputs?: Fc_Home_Artcraft_VectorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Artcraft_VectorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_artcraft_vector(inputs)
});
export { fc_home_artcraft_vector as "fc.home.artcraft.vector" }